import de from '@translations/de/brandForm.json';
import en from '@translations/en/brandForm.json';
import pl from '@translations/pl/brandForm.json';
import sl from '@translations/sl/brandForm.json';
import uk from '@translations/uk/brandForm.json';
import bg from '@translations/bg/brandForm.json';
import cz from '@translations/cz/brandForm.json';
import fr from '@translations/fr/brandForm.json';
import gr from '@translations/gr/brandForm.json';
import it from '@translations/it/brandForm.json';
import pr from '@translations/pr/brandForm.json';
import ru from '@translations/ru/brandForm.json';
import sk from '@translations/sk/brandForm.json';
import sp from '@translations/sp/brandForm.json';
import tr from '@translations/tr/brandForm.json';
import hu from '@translations/hu/brandForm.json';
import { ITranslations } from '@/types/common';
import { BrandFormTransFields } from './types';

export const brandFormTranslations: ITranslations<BrandFormTransFields> = {
  name: 'brandForm',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
